const productVariants = JSON.parse(document.getElementById('product-variants').innerText);
const currentCartItemTags = JSON.parse(document.querySelector('[data-cart-item-tags]').innerText);
const productTags = JSON.parse(document.querySelector('[data-tags]').innerText);
const variantStatus = JSON.parse(document.getElementById('variant-status').innerText);
const quantitySelector = document.getElementById('quantity-select');
const colorSelector = document.getElementById('color-selector');
const sizeSelector = document.getElementById('size-selector');
const styleSelector = document.getElementById('style-selector');
const propertySelectors = document.querySelectorAll('.js-property-select');
const addToCartPC = document.getElementById('add-to-cart-pc');
const soldOut = document.getElementById('sold-out');
console.log(variantStatus);
const CANNOT_SAME_SHIPPING_PRODUCTS = ['BRIDAL', 'FOOD', 'SAMPLERING', 'RESERVATION'];
// 商品のpropertyが変更されたら、カートボタンを表示する
// window.addEventListener('DOMContentLoaded', () => {
//   renderPropertySelect();
//   propertySelectors.forEach((selector) => {
//     selector.addEventListener('change', handlePropertyChange);
//   });
// });

function handlePropertyChange(event) {
  const { name, value } = event.target;
  console.log(name, value);
  updateSelectOptions(name, value);
  const isSelectIsFilled = Array.from(propertySelectors).every((selector) => selector.value !== '');
  console.log(isSelectIsFilled);
  if (isSelectIsFilled) {
    // 対象のVariantが存在するか確認
    const targetVariant = getVariant();
    console.log('targetVariant', targetVariant);
    // 対象のVariantが存在し、在庫も存在する場合、ADD TO CARTを表示する。SOLD OUTを非表示にする。
    if (targetVariant && targetVariant.available) {
      addToCartPC.classList.remove('hide');
      addToCartPC.setAttribute('data-variant-id', targetVariant.id);
      addToCartPC.addEventListener('click', handleAddToCart);
      soldOut.classList.add('hide');
    }
    // 対象のVariantが存在するが、在庫は無かった場合、SOLD OUTを表示する。ADD TO CARTを非表示にする。
    if (targetVariant && !targetVariant.available) {
      soldOut.classList.remove('hide');
      soldOut.setAttribute('data-variant-id', targetVariant.id);
      addToCartPC.classList.add('hide');
      addToCartPC.removeEventListener('click', handleAddToCart);
    }
  } else {
    if (!addToCartPC.classList.contains('hide')) {
      addToCartPC.classList.add('hide');
      addToCartPC.removeEventListener('click', handleAddToCart);
    }
    if (!soldOut.classList.contains('hide')) {
      soldOut.classList.add('hide');
    }
  }
}
/**
 * セレクトボックスの選択肢を生成する
 * @param {string[]} values
 * @return {HTMLOptionElement[]}
 */
const optionsGenerator = (values) => {
  console.log(values);
  const options = values.map((value) => {
    const option = document.createElement('option');
    option.value = value;
    option.innerText = value;
    return option;
  });
  console.log(options);
  return options;
};

function renderPropertySelect() {
  colorSelector.innerHTML = `<option value="">カラーを選択してください</option>`;
  sizeSelector.innerHTML = '<option value="">サイズを選択してください</option>';
  if (styleSelector) {
    styleSelector.innerHTML = '<option value="">スタイルを選択してください</option>';
  }
  // color名の重複を削除する
  const colors = [...new Set(variantStatus.map(({ color }) => color))];
  // size名の重複を削除する
  const sizes = [...new Set(variantStatus.map(({ size }) => size))];
  // style名の重複を削除する
  const styles = [...new Set(variantStatus.map(({ style }) => style))];
  // colorのoptionを生成する (optionのvalueはcolor名)
  const colorOptions = optionsGenerator(colors);
  // sizeのoptionを生成する (optionのvalueはsize名)
  const sizeOptions = optionsGenerator(sizes);
  // styleのoptionを生成する (optionのvalueはstyle名)
  const styleOptions = optionsGenerator(styles);
  // colorのoptionをselectに追加する
  colorOptions.forEach((option) => {
    // カラーは、variantStatusの該当カラーのis_showが全てfalseの場合は非表示にする
    const isHide = variantStatus
      .filter((status) => status.color === option.value)
      .every((status) => !status.is_show);
    if (isHide) {
      option.classList.add('hide');
    }
    colorSelector.appendChild(option);
  });
  // sizeのoptionをselectに追加する
  sizeOptions.forEach((option) => {
    sizeSelector.appendChild(option);
  });
  // styleのoptionをselectに追加する
  if (styleOptions.length > 1 && styleSelector) {
    styleOptions.forEach((option) => {
      styleSelector.appendChild(option);
    });
  }
}
/**
 *
 * @param { 'Size' | 'サイズ' | 'Color' | '色' | 'カラー' | 'Style' | 'スタイル' } type
 * @param {string} value
 */
function updateSelectOptions(type, value) {
  console.log(type, value);
  const isSetColor = type === 'Color' || type === '色' || type === 'カラー';
  const isSetSize = type === 'Size' || type === 'サイズ';
  const isSetStyle = type === 'Style' || type === 'スタイル';
  const colorOptions = colorSelector.querySelectorAll('option');
  const sizeOptions = sizeSelector.querySelectorAll('option');
  const styleOptions = styleSelector ? styleSelector.querySelectorAll('option') : [];
  // colorを選択したとき、同じカラーのsizeのis_showがfalseの選択肢を非表示にして、trueの選択肢を再表示する
  // もし消えたsizeを選択していた場合は、sizeをリセットする
  if (isSetColor && value) {
    // 同じカラーのサイズがis_showのものだけを表示する
    sizeOptions.forEach((option) => {
      const isShow = variantStatus.some((status) => {
        return status.color === value && status.size === option.value && status.is_show;
      });
      if (isShow) {
        option.classList.remove('hide');
      } else {
        option.classList.add('hide');
      }
    });
    // 同じカラーのスタイルがis_showのものだけを表示する
    styleOptions.forEach((option) => {
      const isShow = variantStatus.some((status) => {
        return status.color === value && status.style === option.value && status.is_show;
      });
      if (isShow) {
        option.classList.remove('hide');
      } else {
        option.classList.add('hide');
      }
    });
    // もし、選択したカラーにis_showがtrueのサイズがない場合は、サイズをリセットする
    const isShowSize = variantStatus.some((status) => {
      return status.color === value && status.is_show;
    });
    if (!isShowSize) {
      sizeSelector.value = '';
    }
    // もし、選択したカラーにis_showがtrueのスタイルがない場合は、スタイルをリセットする
    const isShowStyle = variantStatus.some((status) => {
      return status.color === value && status.is_show;
    });
    if (!isShowStyle && styleSelector) {
      styleSelector.value = '';
    }
  }
  if (isSetSize && value) {
    // 同じサイズのカラーがis_showのものだけを表示する
    colorOptions.forEach((option) => {
      const isShow = variantStatus.some((status) => {
        return status.size === value && status.color === option.value && status.is_show;
      });
      if (isShow) {
        option.classList.remove('hide');
      } else {
        option.classList.add('hide');
      }
    });
    // 同じサイズのスタイルがis_showのものだけを表示する
    styleOptions.forEach((option) => {
      const isShow = variantStatus.some((status) => {
        return status.size === value && status.style === option.value && status.is_show;
      });
      if (isShow) {
        option.classList.remove('hide');
      } else {
        option.classList.add('hide');
      }
    });
    // もし、選択したサイズにis_showがtrueのカラーがない場合は、カラーをリセットする
    const isShowColor = variantStatus.some((status) => {
      return status.size === value && status.is_show;
    });
    if (!isShowColor) {
      colorSelector.value = '';
    }
    // もし、選択したサイズにis_showがtrueのスタイルがない場合は、スタイルをリセットする
    const isShowStyle = variantStatus.some((status) => {
      return status.size === value && status.is_show;
    });
    if (!isShowStyle && styleSelector) {
      styleSelector.value = '';
    }
  }
  if (isSetStyle && value) {
    // 同じスタイルのカラーがis_showのものだけを表示する
    colorOptions.forEach((option) => {
      const isShow = variantStatus.some((status) => {
        return status.style === value && status.color === option.value && status.is_show;
      });
      if (isShow) {
        option.classList.remove('hide');
      } else {
        option.classList.add('hide');
      }
    });
    // 同じスタイルのサイズがis_showのものだけを表示する
    sizeOptions.forEach((option) => {
      const isShow = variantStatus.some((status) => {
        return status.style === value && status.size === option.value && status.is_show;
      });
      if (isShow) {
        option.classList.remove('hide');
      } else {
        option.classList.add('hide');
      }
    });
    // もし、選択したスタイルにis_showがtrueのカラーがない場合は、カラーをリセットする
    const isShowColor = variantStatus.some((status) => {
      return status.style === value && status.is_show;
    });
    if (!isShowColor) {
      colorSelector.value = '';
    }
    // もし、選択したスタイルにis_showがtrueのサイズがない場合は、サイズをリセットする
    const isShowSize = variantStatus.some((status) => {
      return status.style === value && status.is_show;
    });
    if (!isShowSize) {
      sizeSelector.value = '';
    }
  }
}

function handleAddToCart(event) {
  if (checkUnableToAdd()) {
    addToCart(event);
  } else {
    if (productTypeCheck() === 'NORMAL') {
      alert(
        '食品やサンプルリング、ブライダル商品は同時に購入できません。\nカートを確認し、購入を完了するか商品を削除してください。'
      );
      return;
    } else {
      alert(
        'この商品は他カテゴリの商品と同時に注文することができません。恐れ入りますが個別にご注文ください。'
      );
      return;
    }
  }
}

/**
 * 選択されたSelectorの値からVariantのIDを取得する
 * @returns {Variant} variantオブジェクト
 */
function getVariant() {
  const selectedColor = colorSelector?.value ?? null;
  const selectedSize = sizeSelector?.value ?? null;
  const selectedStyle = styleSelector?.value ?? null;
  const selectedVariant = productVariants.find((variant) => {
    // カラーとサイズとスタイル全てが選択されている場合
    if (selectedColor && selectedSize && selectedStyle) {
      return (
        variant.option1 === selectedColor &&
        variant.option2 === selectedSize &&
        variant.option3 === selectedStyle
      );
    }

    // カラーとサイズが選択されている場合
    if (selectedColor && selectedSize) {
      return variant.option1 === selectedColor && variant.option2 === selectedSize;
    }

    // サイズのみ選択されている場合
    if (!selectedColor && selectedSize) {
      return variant.option2 === selectedSize;
    }

    // カラーのみ選択されている場合
    if (selectedColor && !selectedSize) {
      return variant.option1 === selectedColor;
    }
  });

  console.log('selectedVariant', selectedVariant);
  // 対象のVariantが存在すれば、そのVariantを返す
  if (selectedVariant) {
    return selectedVariant;
    // 対象のVariantが存在しなければ、nullを返す
  } else {
    return null;
  }
}
/**
 * 対象variantをカートに追加する
 * @param {number} variantId
 */
function addToCart(event) {
  console.log('event', event.target);
  const quantity = quantitySelector.value;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: [
        {
          quantity: Number(quantity),
          id: Number(event.currentTarget.dataset.variantId),
        },
      ],
    }),
  })
    .then((res) => res.json())
    .then((json) => {
      console.log(json);
      if (json?.items) {
        window.location.href = '/cart';
      } else {
        throw new Error(json.description);
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      alert(error);
    });
}

const checkUnableToAdd = () => {
  const productType = productTypeCheck();
  const cartItemsType = cartItemsCheck();
  if (currentCartItemTags.length === 0) {
    return true;
  }
  if (productType === cartItemsType) {
    return true;
  }
  if (productType === 'BEFORE_CARE') {
    return true;
  }
  return false;
};

const productTypeCheck = () => {
  if (productTags.includes('BEFORE_CARE')) {
    return 'BEFORE_CARE';
  }
  if (productTags.includes('BRIDAL')) {
    return 'BRIDAL';
  }
  if (productTags.includes('FOOD')) {
    return 'FOOD';
  }
  if (productTags.includes('SAMPLERING')) {
    return 'SAMPLERING';
  }
  if (productTags.includes('予約商品')) {
    return 'RESERVATION';
  }
  return 'NORMAL';
};

const cartItemsCheck = () => {
  if (currentCartItemTags.includes('BRIDAL')) {
    return 'BRIDAL';
  }
  if (currentCartItemTags.includes('FOOD')) {
    return 'FOOD';
  }
  if (currentCartItemTags.includes('SAMPLERING')) {
    return 'SAMPLERING';
  }
  if (productTags.includes('予約商品')) {
    return 'RESERVATION';
  }
  return 'NORMAL';
};
